import { Box, Paper, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { MinimalPageLayout } from '../components/Navigation/MinimalLayout/MinimalPageLayout';
import { StayInContactIcon } from '../components/Shared/StayInContactIcon';

export default function OrderCancelledPage() {
    const { classes } = useStyles();

    const { sessionId } = useParams<{ sessionId: string }>();

    return (
        <MinimalPageLayout>
            <StayInContactIcon className={classes.icon} />
            <Paper className={classes.paper}>
                <Box p={4}>
                    <Typography variant="h5" align="center">
                        Order Cancelled... {sessionId}
                    </Typography>
                </Box>
            </Paper>
        </MinimalPageLayout>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        [theme.breakpoints.up('xs')]: {
            maxWidth: '80%',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '60%',
        },
    },
    nestedFlex: {
        width: '100%',
        textAlign: 'center',
    },
    linkText: {
        color: theme.palette.common.white,
    },
    icon: {
        maxWidth: '250px',
    },
}));
